import type { TimelineEntry } from '@zealot/ui/components/activity/timeline-entry';
import { Avatar, AvatarFallback } from '@zealot/ui/components/avatar';
import { HStack } from '@zealot/ui/components/hstack';
import { Text } from '@zealot/ui/components/text';
import { getAvatarAccent } from '@zealot/ui/lib/getAvatarAccent';
import { getInitials } from '@zealot/ui/lib/getInitials';
import { User } from 'lucide-react';
import type { ReactNode } from 'react';

// gloss
const AuthorAvatar = ({ name }: { name?: string | null }) => (
  <Avatar size="xs" aria-hidden="true" data-slot="activity-timeline-note-avatar">
    {name ? (
      <AvatarFallback accent={getAvatarAccent(name)}>{getInitials(name)}</AvatarFallback>
    ) : (
      <AvatarFallback>
        <User />
      </AvatarFallback>
    )}
  </Avatar>
);

type TimelineNoteCardProps = {
  entry: TimelineEntry;
  action?: ReactNode;
};

// gloss
export const TimelineNoteCard = ({ entry, action }: TimelineNoteCardProps) => (
  <div
    className="mb-4 min-w-0 flex-1 rounded-lg border border-border bg-muted/30 p-3"
    data-slot="activity-timeline-note"
  >
    <HStack gap={2}>
      <AuthorAvatar name={entry.actorLabel} />
      {entry.actorLabel && (
        <Text size="sm" weight="medium" truncate render={<span />}>
          {entry.actorLabel}
        </Text>
      )}
      {entry.timestamp && <span className="shrink-0 text-muted-foreground text-xs">{entry.timestamp}</span>}
      {action && (
        <div className="ml-auto shrink-0" data-slot="activity-timeline-entry-action">
          {action}
        </div>
      )}
    </HStack>
    {}
    <Text size="sm" className="mt-2 whitespace-pre-wrap break-words">
      {entry.title}
    </Text>
    {entry.secondary && <span className="mt-1 block text-muted-foreground text-xs">{entry.secondary}</span>}
  </div>
);
